import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'us-registration-appliance-details-stepped-wib-content-toggle',
  standalone: true,
  imports: [NgIf],
  templateUrl: './appliance-details-stepped-wib-content-toggle.component.html',
  styleUrls: ['./appliance-details-stepped-wib-content-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplianceDetailsSteppedWibContentToggleComponent {
  @Input() toggleLabel = '';
  @Input() textBefore = '';
  displayContent = false;

  contentToggle(): void {
    this.displayContent = !this.displayContent;
  }
}
